// extracted by mini-css-extract-plugin
export default {"content":"N8Dztm0mZjJaHhlKapyz"};